/**
 * Cores dos graficos dos relatorios lidas dos tokens do tema (--slate-11,
 * --teal-9...) na hora de desenhar.
 *
 * O chart.js desenha em canvas e nao enxerga classe do Tailwind: antes as
 * cores eram hex fixos pensados para fundo escuro (#94a3b8 no eixo, tooltip
 * #e2e8f0 sobre slate-800) e somiam no tema claro. Os tokens ja trocam de
 * valor com o tema (o modo escuro e a classe `dark` no body, ver
 * dashboard/helper/themeHelper.js), entao ler o token do body resolve os dois.
 *
 * Os valores fixos abaixo so entram quando o token nao existe (teste sem o
 * CSS do app).
 */

const FALLBACK = {
  light: {
    'slate-11': '96, 100, 108',
    'slate-12': '28, 32, 36',
    'slate-6': '217, 217, 224',
    'slate-1': '252, 252, 253',
    'blue-9': '39, 129, 246',
    'teal-9': '18, 165, 148',
    'amber-9': '255, 197, 61',
    'ruby-9': '229, 70, 102',
  },
  dark: {
    'slate-11': '176, 180, 186',
    'slate-12': '237, 238, 240',
    'slate-6': '54, 58, 63',
    'slate-1': '17, 17, 19',
    'blue-9': '39, 129, 246',
    'teal-9': '18, 165, 148',
    'amber-9': '255, 197, 61',
    'ruby-9': '229, 70, 102',
  },
};

const isDarkTheme = () =>
  typeof document !== 'undefined' &&
  !!document.body &&
  document.body.classList.contains('dark');

// "96 100 108" (formato do token) vira "96, 100, 108", que o parser de cor do
// chart.js e qualquer canvas aceitam.
const readToken = name => {
  if (typeof document === 'undefined' || !document.body) return '';
  const raw = window
    .getComputedStyle(document.body)
    .getPropertyValue(`--${name}`)
    .trim();
  const parts = raw.split(/[\s,]+/).filter(Boolean);
  return parts.length >= 3 ? parts.slice(0, 3).join(', ') : '';
};

/** Cor de um token do tema (ex.: 'teal-9'), com transparencia opcional. */
export const themeColor = (name, alpha) => {
  const channels =
    readToken(name) || FALLBACK[isDarkTheme() ? 'dark' : 'light'][name];
  if (!channels) return undefined;
  return alpha === undefined
    ? `rgb(${channels})`
    : `rgba(${channels}, ${alpha})`;
};

export const getChartThemeColors = () => ({
  tick: themeColor('slate-11'),
  legend: themeColor('slate-11'),
  grid: themeColor('slate-6', 0.6),
  // Tooltip invertido: fundo do texto forte e texto do fundo, legivel nos dois
  // temas (mockup aprovado do funil).
  tooltipBg: themeColor('slate-12'),
  tooltipText: themeColor('slate-1'),
  series: themeColor('blue-9'),
  success: themeColor('teal-9'),
  warning: themeColor('amber-9'),
  danger: themeColor('ruby-9'),
});
